import { render, staticRenderFns } from "./BeerPage.vue?vue&type=template&id=f4f65f98&scoped=true&lang=html&"
import script from "./BeerPage.vue?vue&type=script&lang=js&"
export * from "./BeerPage.vue?vue&type=script&lang=js&"
import style0 from "./BeerPage.vue?vue&type=style&index=0&id=f4f65f98&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f65f98",
  null
  
)

export default component.exports